import {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class AdminNotes extends Component {
  static propTypes = {
    notes: PropTypes.arrayOf(PropTypes.shape({
      propertyId: PropTypes.number.isRequired,
      username: PropTypes.string.isRequired,
      franchiseId: PropTypes.string.isRequired,
      franchiseName: PropTypes.string.isRequired,
      notes: PropTypes.string.isRequired,
    }).isRequired).isRequired
  };

  render() {
    const {notes} = this.props;
    return (
      <div className="notes-table">
        <table>
          <thead>
          <tr>
            <th>Property Id</th>
            <th>Username</th>
            <th>Franchise Id</th>
            <th>Franchise Name</th>
            <th width="40%">Notes</th>
            <th>Created</th>
          </tr>
          </thead>
          <tbody>
          {notes.map((adminNote) => (
            <tr key={adminNote.propertyId}>
              <td className="property-id">
                <a href={`https://rpp.rpdata.com/rpp/property/detail.html?propertyId=${adminNote.propertyId}`}
                   target="_blank"
                   rel="noopener noreferrer">
                  {adminNote.propertyId}
                </a>
              </td>
              <td className="username">{adminNote.username}</td>
              <td className="franchise-id">{adminNote.franchiseId}</td>
              <td className="franchise-name">{adminNote.franchiseName}</td>
              <td className="notes" >{adminNote.notes}</td>
              <td className="created">{moment(adminNote.created).format('YYYY-MM-DD hh:mm A')}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    );
  }
}